import { graphql } from "msw";
import { getFaker } from "Apimocks/utils/getFaker";
import { generateSettingsKeys } from "./settingsOptions.js";

let idCount = 1;
let notificationSettingsObj;
const notificationsetting = async () => {
    const faker = await getFaker();
    return notificationSettingsObj || {
        ...Object.fromEntries(
            generateSettingsKeys.map(([ key, maybeValue ]) => [ key, (maybeValue ?? (key.includes("DIGEST") ? "NEVER" : faker.random.boolean())) ])
        ),
        _id: idCount++,
    };
};


export const handlers = [
    graphql.query("projectNotificationSettings", async (req, res, ctx) => {
        const settings = await notificationsetting();
        return res(ctx.delay(), ctx.data({ subscribeNotificationSetting: settings }));
    }),
    graphql.mutation("updateProjectNotificationSettings", (req, res, ctx) => {
        const { notificationSettings } = req.variables;

        const current = notificationSettingsObj || {};
        // eslint-disable-next-line no-underscore-dangle
        const id = current._id || idCount++;
          
        const updatedNotificationSetting = {
            ...notificationSettings,
            _id: id,
        };
        notificationSettingsObj = updatedNotificationSetting;         
        return res(ctx.delay(), ctx.data({ updateProjectNotificationSettings: updatedNotificationSetting }));
    })
];
